// frontend/src/contexts/AuthContext.js
import React, { useContext, useState, useEffect } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Add imports
import { db } from "../firebase";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Fetch Role from Firestore
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists()) {
            const userData = userDoc.data();
            
            // SECURITY CHECK: Kick them out if disabled
            if (userData.isDisabled) {
                await signOut(auth);
                alert("Your account has been disabled by an administrator.");
                setCurrentUser(null);
                setLoading(false);
                return;
            }

            // Merge Auth user with Firestore data (role, assignedModels)
            setCurrentUser({ ...user, ...userData });
        } else {
            // Fallback for initial admin setup (if not in DB yet)
            // If you manually created the admin in console, they won't have a doc yet.
            // We treat them as a basic user or admin default.
            setCurrentUser({ ...user, role: 'admin' }); 
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}